export default __webpack_public_path__ + "static/media/icon-earth.9c4aab12.svg";